import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StoredConsolidationPreviewQueryVariables = Types.Exact<{
  previewId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StoredConsolidationPreviewQuery = { __typename?: 'Query', storedConsolidationPreview?: { __typename?: 'ConsolidationPreview', id: string, createdAt: Types.TDateISO, createdBy: string, expiresAt: Types.TDateISO, productionPlanIds: Array<string>, scenario: Types.ConsolidationScenario, rulesVersion: number, computeMilliseconds: number, summary: { __typename?: 'ConsolidationPreviewSummary', lotsBefore: number, lotsAfter: number, quantityBefore: number, quantityAfter: number, smallLotUnder: number, smallLotsBefore: number, smallLotsAfter: number, runCount: number, lotsKeptAtPlannerSite: number, lotsWithoutRecipe: number, lotsBoundToOrder: number, pinnedLots: number, windowEdgeNoteCount: number, runStatusCounts: Array<{ __typename?: 'ConsolidationRunStatusCount', status: Types.ConsolidationRunStatus, count: number }>, bridge: Array<{ __typename?: 'ConsolidationBridgeLine', kind: Types.ConsolidationBridgeKind, quantity: number, lots: number }>, steps: Array<{ __typename?: 'ConsolidationStepImpact', step: Types.ConsolidationStep, change: Types.ConsolidationLotChange, lots: number, quantity: number }> }, runs: Array<{ __typename?: 'ConsolidationPreviewRun', productionPlanId: string, siteLocationId: string, productionCategoryId: string, genera: Array<string>, startWeek: Types.TDateISO, quantity: number, containers?: number | null, minimumEaches?: number | null, slowWeek: boolean, status: Types.ConsolidationRunStatus, mergedStartWeeks: Array<Types.TDateISO> }>, windowEdgeNotes: Array<{ __typename?: 'ConsolidationWindowEdgeNote', customerGroupId: string, productionCategoryId: string, genus?: string | null, edge: Types.ConsolidationWindowEdge, readyWeek: Types.TDateISO, quantity: number, neighborReadyWeek?: Types.TDateISO | null, neighborQuantity?: number | null }>, plannerChanges: Array<{ __typename?: 'ConsolidationPlannerChangeGroup', kind: Types.ConsolidationPlannerChangeKind, lots: number, quantity: number, firstChangedAt?: Types.TDateISO | null, lastChangedAt?: Types.TDateISO | null, kept: boolean }>, space: Array<{ __typename?: 'ConsolidationSpaceImpact', siteLocationId: string, spaceTypeId: string, approximate: boolean, before: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, after: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, weeks: Array<{ __typename?: 'ConsolidationSpaceWeek', week: Types.TDateISO, before: number, after: number, capacity: number }> }> } | null };

export type ConsolidationPreviewLotsQueryVariables = Types.Exact<{
  previewId: Types.Scalars['String']['input'];
  skip: Types.Scalars['Int']['input'];
  take: Types.Scalars['Int']['input'];
}>;


export type ConsolidationPreviewLotsQuery = { __typename?: 'Query', consolidationPreviewLots: { __typename?: 'ConsolidationPreviewLotsPayload', totalCount: number, success: boolean, lots: Array<{ __typename?: 'ConsolidationPreviewLot', productionLotId: string, lotNumber: number, outcome: Types.ConsolidationLotOutcome, absorbedIntoProductionLotId?: string | null, changes: Array<Types.ConsolidationLotChange>, runStatus?: Types.ConsolidationRunStatus | null, pinned: boolean, boundToOrder: boolean, customerId?: string | null, customerGroupId?: string | null, productionCategoryId: string, productionCatalogId: string, genus?: string | null, series?: string | null, color?: string | null, productionPlanIdBefore: string, productionPlanIdAfter: string, siteLocationIdBefore?: string | null, siteLocationIdAfter?: string | null, rulesSiteLocationId?: string | null, plannerSiteLocationId?: string | null, readyWeekBefore: Types.TDateISO, readyWeekAfter: Types.TDateISO, startWeekBefore: Types.TDateISO, startWeekAfter: Types.TDateISO, quantityBefore: number, quantityAfter: number }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConsolidationApplicationQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['String']['input'];
}>;


export type ConsolidationApplicationQuery = { __typename?: 'Query', consolidationApplication?: { __typename?: 'ConsolidationApplication', id: string, previewId: string, productionPlanIds: Array<string>, rulesVersion: number, scenario: Types.ConsolidationScenario, status: Types.ConsolidationApplicationStatus, appliedAt: Types.TDateISO, appliedBy: string, finishedAt?: Types.TDateISO | null, undoneAt?: Types.TDateISO | null, undoneBy?: string | null, lotsTotal: number, lotsDone: number, lotsCreated: number, lotsChanged: number, lotsAbsorbed: number, lotsRemoved: number, lotsMovedToPlan: number, quantityBefore: number, quantityAfter: number, quantityRemoved: number, error?: string | null } | null };

export type ConsolidationApplicationsQueryVariables = Types.Exact<{
  productionPlanIds?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  take: Types.Scalars['Int']['input'];
}>;


export type ConsolidationApplicationsQuery = { __typename?: 'Query', consolidationApplications: Array<{ __typename?: 'ConsolidationApplication', id: string, previewId: string, productionPlanIds: Array<string>, rulesVersion: number, scenario: Types.ConsolidationScenario, status: Types.ConsolidationApplicationStatus, appliedAt: Types.TDateISO, appliedBy: string, finishedAt?: Types.TDateISO | null, undoneAt?: Types.TDateISO | null, undoneBy?: string | null, lotsTotal: number, lotsDone: number, lotsCreated: number, lotsChanged: number, lotsAbsorbed: number, lotsRemoved: number, lotsMovedToPlan: number, quantityBefore: number, quantityAfter: number, quantityRemoved: number, error?: string | null }> };

export type ConsolidationApplicationLotsQueryVariables = Types.Exact<{
  applicationId: Types.Scalars['String']['input'];
}>;


export type ConsolidationApplicationLotsQuery = { __typename?: 'Query', consolidationApplicationLots: Array<{ __typename?: 'ConsolidationApplicationLot', productionLotId: string, lotNumber: number, outcome: string, changes: Array<Types.ConsolidationLotChange>, newProductionLotId?: string | null, newLotNumber?: number | null, productionPlanIdBefore: string, productionPlanIdAfter: string, siteLocationIdBefore?: string | null, siteLocationIdAfter?: string | null, readyWeekBefore: Types.TDateISO, readyWeekAfter: Types.TDateISO, quantityBefore: number, quantityAfter: number }> };

export type ConsolidationPreviewFieldsFragment = { __typename?: 'ConsolidationPreview', id: string, createdAt: Types.TDateISO, createdBy: string, expiresAt: Types.TDateISO, productionPlanIds: Array<string>, scenario: Types.ConsolidationScenario, rulesVersion: number, computeMilliseconds: number, summary: { __typename?: 'ConsolidationPreviewSummary', lotsBefore: number, lotsAfter: number, quantityBefore: number, quantityAfter: number, smallLotUnder: number, smallLotsBefore: number, smallLotsAfter: number, runCount: number, lotsKeptAtPlannerSite: number, lotsWithoutRecipe: number, lotsBoundToOrder: number, pinnedLots: number, windowEdgeNoteCount: number, runStatusCounts: Array<{ __typename?: 'ConsolidationRunStatusCount', status: Types.ConsolidationRunStatus, count: number }>, bridge: Array<{ __typename?: 'ConsolidationBridgeLine', kind: Types.ConsolidationBridgeKind, quantity: number, lots: number }>, steps: Array<{ __typename?: 'ConsolidationStepImpact', step: Types.ConsolidationStep, change: Types.ConsolidationLotChange, lots: number, quantity: number }> }, runs: Array<{ __typename?: 'ConsolidationPreviewRun', productionPlanId: string, siteLocationId: string, productionCategoryId: string, genera: Array<string>, startWeek: Types.TDateISO, quantity: number, containers?: number | null, minimumEaches?: number | null, slowWeek: boolean, status: Types.ConsolidationRunStatus, mergedStartWeeks: Array<Types.TDateISO> }>, windowEdgeNotes: Array<{ __typename?: 'ConsolidationWindowEdgeNote', customerGroupId: string, productionCategoryId: string, genus?: string | null, edge: Types.ConsolidationWindowEdge, readyWeek: Types.TDateISO, quantity: number, neighborReadyWeek?: Types.TDateISO | null, neighborQuantity?: number | null }>, plannerChanges: Array<{ __typename?: 'ConsolidationPlannerChangeGroup', kind: Types.ConsolidationPlannerChangeKind, lots: number, quantity: number, firstChangedAt?: Types.TDateISO | null, lastChangedAt?: Types.TDateISO | null, kept: boolean }>, space: Array<{ __typename?: 'ConsolidationSpaceImpact', siteLocationId: string, spaceTypeId: string, approximate: boolean, before: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, after: { __typename?: 'ConsolidationSpacePeak', peakPercent: number, peakWeek?: Types.TDateISO | null, weeksOver: number }, weeks: Array<{ __typename?: 'ConsolidationSpaceWeek', week: Types.TDateISO, before: number, after: number, capacity: number }> }> };

export type ConsolidationPreviewLotFieldsFragment = { __typename?: 'ConsolidationPreviewLot', productionLotId: string, lotNumber: number, outcome: Types.ConsolidationLotOutcome, absorbedIntoProductionLotId?: string | null, changes: Array<Types.ConsolidationLotChange>, runStatus?: Types.ConsolidationRunStatus | null, pinned: boolean, boundToOrder: boolean, customerId?: string | null, customerGroupId?: string | null, productionCategoryId: string, productionCatalogId: string, genus?: string | null, series?: string | null, color?: string | null, productionPlanIdBefore: string, productionPlanIdAfter: string, siteLocationIdBefore?: string | null, siteLocationIdAfter?: string | null, rulesSiteLocationId?: string | null, plannerSiteLocationId?: string | null, readyWeekBefore: Types.TDateISO, readyWeekAfter: Types.TDateISO, startWeekBefore: Types.TDateISO, startWeekAfter: Types.TDateISO, quantityBefore: number, quantityAfter: number };

export type ConsolidationApplicationFieldsFragment = { __typename?: 'ConsolidationApplication', id: string, previewId: string, productionPlanIds: Array<string>, rulesVersion: number, scenario: Types.ConsolidationScenario, status: Types.ConsolidationApplicationStatus, appliedAt: Types.TDateISO, appliedBy: string, finishedAt?: Types.TDateISO | null, undoneAt?: Types.TDateISO | null, undoneBy?: string | null, lotsTotal: number, lotsDone: number, lotsCreated: number, lotsChanged: number, lotsAbsorbed: number, lotsRemoved: number, lotsMovedToPlan: number, quantityBefore: number, quantityAfter: number, quantityRemoved: number, error?: string | null };

export type ConsolidationApplicationLotFieldsFragment = { __typename?: 'ConsolidationApplicationLot', productionLotId: string, lotNumber: number, outcome: string, changes: Array<Types.ConsolidationLotChange>, newProductionLotId?: string | null, newLotNumber?: number | null, productionPlanIdBefore: string, productionPlanIdAfter: string, siteLocationIdBefore?: string | null, siteLocationIdAfter?: string | null, readyWeekBefore: Types.TDateISO, readyWeekAfter: Types.TDateISO, quantityBefore: number, quantityAfter: number };

export const ConsolidationPreviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationPreviewFields on ConsolidationPreview {
  id
  createdAt
  createdBy
  expiresAt
  productionPlanIds
  scenario
  rulesVersion
  computeMilliseconds
  summary {
    lotsBefore
    lotsAfter
    quantityBefore
    quantityAfter
    smallLotUnder
    smallLotsBefore
    smallLotsAfter
    runCount
    runStatusCounts {
      status
      count
    }
    lotsKeptAtPlannerSite
    lotsWithoutRecipe
    lotsBoundToOrder
    pinnedLots
    windowEdgeNoteCount
    bridge {
      kind
      quantity
      lots
    }
    steps {
      step
      change
      lots
      quantity
    }
  }
  runs {
    productionPlanId
    siteLocationId
    productionCategoryId
    genera
    startWeek
    quantity
    containers
    minimumEaches
    slowWeek
    status
    mergedStartWeeks
  }
  windowEdgeNotes {
    customerGroupId
    productionCategoryId
    genus
    edge
    readyWeek
    quantity
    neighborReadyWeek
    neighborQuantity
  }
  plannerChanges {
    kind
    lots
    quantity
    firstChangedAt
    lastChangedAt
    kept
  }
  space {
    siteLocationId
    spaceTypeId
    approximate
    before {
      peakPercent
      peakWeek
      weeksOver
    }
    after {
      peakPercent
      peakWeek
      weeksOver
    }
    weeks {
      week
      before
      after
      capacity
    }
  }
}
    `, {"fragmentName":"ConsolidationPreviewFields"});
export const ConsolidationPreviewLotFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationPreviewLotFields on ConsolidationPreviewLot {
  productionLotId
  lotNumber
  outcome
  absorbedIntoProductionLotId
  changes
  runStatus
  pinned
  boundToOrder
  customerId
  customerGroupId
  productionCategoryId
  productionCatalogId
  genus
  series
  color
  productionPlanIdBefore
  productionPlanIdAfter
  siteLocationIdBefore
  siteLocationIdAfter
  rulesSiteLocationId
  plannerSiteLocationId
  readyWeekBefore
  readyWeekAfter
  startWeekBefore
  startWeekAfter
  quantityBefore
  quantityAfter
}
    `, {"fragmentName":"ConsolidationPreviewLotFields"});
export const ConsolidationApplicationFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationApplicationFields on ConsolidationApplication {
  id
  previewId
  productionPlanIds
  rulesVersion
  scenario
  status
  appliedAt
  appliedBy
  finishedAt
  undoneAt
  undoneBy
  lotsTotal
  lotsDone
  lotsCreated
  lotsChanged
  lotsAbsorbed
  lotsRemoved
  lotsMovedToPlan
  quantityBefore
  quantityAfter
  quantityRemoved
  error
}
    `, {"fragmentName":"ConsolidationApplicationFields"});
export const ConsolidationApplicationLotFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationApplicationLotFields on ConsolidationApplicationLot {
  productionLotId
  lotNumber
  outcome
  changes
  newProductionLotId
  newLotNumber
  productionPlanIdBefore
  productionPlanIdAfter
  siteLocationIdBefore
  siteLocationIdAfter
  readyWeekBefore
  readyWeekAfter
  quantityBefore
  quantityAfter
}
    `, {"fragmentName":"ConsolidationApplicationLotFields"});
export const StoredConsolidationPreviewDocument = new TypedDocumentString(`
    query StoredConsolidationPreview($previewId: String) {
  storedConsolidationPreview(previewId: $previewId) {
    ...ConsolidationPreviewFields
  }
}
    fragment ConsolidationPreviewFields on ConsolidationPreview {
  id
  createdAt
  createdBy
  expiresAt
  productionPlanIds
  scenario
  rulesVersion
  computeMilliseconds
  summary {
    lotsBefore
    lotsAfter
    quantityBefore
    quantityAfter
    smallLotUnder
    smallLotsBefore
    smallLotsAfter
    runCount
    runStatusCounts {
      status
      count
    }
    lotsKeptAtPlannerSite
    lotsWithoutRecipe
    lotsBoundToOrder
    pinnedLots
    windowEdgeNoteCount
    bridge {
      kind
      quantity
      lots
    }
    steps {
      step
      change
      lots
      quantity
    }
  }
  runs {
    productionPlanId
    siteLocationId
    productionCategoryId
    genera
    startWeek
    quantity
    containers
    minimumEaches
    slowWeek
    status
    mergedStartWeeks
  }
  windowEdgeNotes {
    customerGroupId
    productionCategoryId
    genus
    edge
    readyWeek
    quantity
    neighborReadyWeek
    neighborQuantity
  }
  plannerChanges {
    kind
    lots
    quantity
    firstChangedAt
    lastChangedAt
    kept
  }
  space {
    siteLocationId
    spaceTypeId
    approximate
    before {
      peakPercent
      peakWeek
      weeksOver
    }
    after {
      peakPercent
      peakWeek
      weeksOver
    }
    weeks {
      week
      before
      after
      capacity
    }
  }
}`);
export const ConsolidationPreviewLotsDocument = new TypedDocumentString(`
    query ConsolidationPreviewLots($previewId: String!, $skip: Int!, $take: Int!) {
  consolidationPreviewLots(previewId: $previewId, skip: $skip, take: $take) {
    lots {
      ...ConsolidationPreviewLotFields
    }
    totalCount
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationPreviewLotFields on ConsolidationPreviewLot {
  productionLotId
  lotNumber
  outcome
  absorbedIntoProductionLotId
  changes
  runStatus
  pinned
  boundToOrder
  customerId
  customerGroupId
  productionCategoryId
  productionCatalogId
  genus
  series
  color
  productionPlanIdBefore
  productionPlanIdAfter
  siteLocationIdBefore
  siteLocationIdAfter
  rulesSiteLocationId
  plannerSiteLocationId
  readyWeekBefore
  readyWeekAfter
  startWeekBefore
  startWeekAfter
  quantityBefore
  quantityAfter
}`);
export const ConsolidationApplicationDocument = new TypedDocumentString(`
    query ConsolidationApplication($applicationId: String!) {
  consolidationApplication(applicationId: $applicationId) {
    ...ConsolidationApplicationFields
  }
}
    fragment ConsolidationApplicationFields on ConsolidationApplication {
  id
  previewId
  productionPlanIds
  rulesVersion
  scenario
  status
  appliedAt
  appliedBy
  finishedAt
  undoneAt
  undoneBy
  lotsTotal
  lotsDone
  lotsCreated
  lotsChanged
  lotsAbsorbed
  lotsRemoved
  lotsMovedToPlan
  quantityBefore
  quantityAfter
  quantityRemoved
  error
}`);
export const ConsolidationApplicationsDocument = new TypedDocumentString(`
    query ConsolidationApplications($productionPlanIds: [String!], $take: Int!) {
  consolidationApplications(productionPlanIds: $productionPlanIds, take: $take) {
    ...ConsolidationApplicationFields
  }
}
    fragment ConsolidationApplicationFields on ConsolidationApplication {
  id
  previewId
  productionPlanIds
  rulesVersion
  scenario
  status
  appliedAt
  appliedBy
  finishedAt
  undoneAt
  undoneBy
  lotsTotal
  lotsDone
  lotsCreated
  lotsChanged
  lotsAbsorbed
  lotsRemoved
  lotsMovedToPlan
  quantityBefore
  quantityAfter
  quantityRemoved
  error
}`);
export const ConsolidationApplicationLotsDocument = new TypedDocumentString(`
    query ConsolidationApplicationLots($applicationId: String!) {
  consolidationApplicationLots(applicationId: $applicationId) {
    ...ConsolidationApplicationLotFields
  }
}
    fragment ConsolidationApplicationLotFields on ConsolidationApplicationLot {
  productionLotId
  lotNumber
  outcome
  changes
  newProductionLotId
  newLotNumber
  productionPlanIdBefore
  productionPlanIdAfter
  siteLocationIdBefore
  siteLocationIdAfter
  readyWeekBefore
  readyWeekAfter
  quantityBefore
  quantityAfter
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StoredConsolidationPreview: build.query<StoredConsolidationPreviewQuery, StoredConsolidationPreviewQueryVariables | void>({
      query: (variables) => ({ document: StoredConsolidationPreviewDocument, variables })
    }),
    ConsolidationPreviewLots: build.query<ConsolidationPreviewLotsQuery, ConsolidationPreviewLotsQueryVariables>({
      query: (variables) => ({ document: ConsolidationPreviewLotsDocument, variables })
    }),
    ConsolidationApplication: build.query<ConsolidationApplicationQuery, ConsolidationApplicationQueryVariables>({
      query: (variables) => ({ document: ConsolidationApplicationDocument, variables })
    }),
    ConsolidationApplications: build.query<ConsolidationApplicationsQuery, ConsolidationApplicationsQueryVariables>({
      query: (variables) => ({ document: ConsolidationApplicationsDocument, variables })
    }),
    ConsolidationApplicationLots: build.query<ConsolidationApplicationLotsQuery, ConsolidationApplicationLotsQueryVariables>({
      query: (variables) => ({ document: ConsolidationApplicationLotsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStoredConsolidationPreviewQuery, useLazyStoredConsolidationPreviewQuery, useConsolidationPreviewLotsQuery, useLazyConsolidationPreviewLotsQuery, useConsolidationApplicationQuery, useLazyConsolidationApplicationQuery, useConsolidationApplicationsQuery, useLazyConsolidationApplicationsQuery, useConsolidationApplicationLotsQuery, useLazyConsolidationApplicationLotsQuery } = injectedRtkApi;
